const ModulePickerEmits = {
  change: (_data) => true,
  update: (_data) => true,
  message: (_data) => true,
  switchover: (_mode) => true
};

export { ModulePickerEmits };
//# sourceMappingURL=types.mjs.map
